import vuelidateErrorExtractor from 'vuelidate-error-extractor'
import singleErrorExtractor from '@/components/errors/UiSingleErrorExtractor.vue'

const options = {
  template: singleErrorExtractor,
  messages: {
    required: 'Данное поле обязательно.',
    email: 'Поле должно быть электронным адресом.',
    maxLength: 'Максимальная длина поля {max} символов.',
    minLength: 'Минимальная длина поля {min} символов.',
    decimal: 'Поле должно быть десятичным числом.',
    sameAs: 'Пароли не совпадают.',
    requireNum: 'Необходимо наличие цифры.',
    requireBigAlpha: 'Необходимо наличие большой буквы.',
    requireSmallAlpha: 'Необходимо наличие маленькой буквы.',
    onlyAlphaAndSpecSymbols: 'Допустимы только латинские буквы и спец. символы.',
  },
}

export { vuelidateErrorExtractor, options }
